<template>
    <div>
        <public-title :showBack="Boolean(queryCon.GST)">导游管理</public-title>
        <el-tabs v-model="activeName" type="card" @tab-click="getDataLists">
        <el-tab-pane v-for="(item,index) in tabArr" :label="item.title" :name="item.status" :key="index"></el-tab-pane>
        </el-tabs>
        <div class="load-area">
            <el-row class="mb-4">
                <el-col :span="14" class="text-left">
                    <div class="lies">姓名</div>
                    <el-input class="w-30" size="small" placeholder="请输入姓名" v-model="title" />
                    <div class="lies  ml-3" >手机号</div>
                    <el-input class="w-30"  size="small" placeholder="请输入手机号" v-model="mobile" />
                    <!-- <span class="text-link ml-3" size="small" @click="getDataLists">搜索</span> -->
                    <el-button class="ml-3" type="primary" size="small" @click="getDataLists">搜索</el-button>
                </el-col>
                <el-col :span="10" class="text-right"><el-button type="primary" size="small" @click="toAdd">添加新人</el-button></el-col>
            </el-row>
            <div v-if="AdminDataLists.total<=0" class="mt-3">当前没有数据</div>
            <div v-else>
                <ul class="list-head mt-3"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
                <store-lists v-for="item in AdminDataLists.lists" :key="item.id" :item="item" @goStoreDetail="goStoreDetail"  />
                <el-pagination background layout="prev, pager, next" class="mt-4"
                    :total="AdminDataLists.total" :current-page="Number(queryCon.page)"
                    @current-change="$GFUN.pageChange"/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions,mapState,mapGetters,mapMutations } from 'vuex'
import StoreLists from './StoreLists'
export default {
    name: 'GuideManage',
    components: {StoreLists},
    data () {
        return {
            search: '',
            mobile:'',
            title:'',
            titleArr: ['姓名','手机号码','身份证号','性别','导游级别','从业年限','认证状态','操作'],
            tabArr:[
                {title: '导游', status:'0'},
                {title: '领队', status:'1'},
            ],
            activeName:'0'
        }
    },
    computed: {
        ...mapState(['AdminDataLists', 'userLoginMessage']),
        ...mapGetters(['storeInfo','isGroup']),
        queryCon () { return  this.$route.query }
    },
    watch:{
      'queryCon.page'() { this.getDataLists() }
    },
    created () {
        if(this.$route.query.tab){
            this.activeName=`${this.$route.query.tab}`
        }
        this.getDataLists();
    }, 
    beforeDestroy() {
      this.UPDATECURRENTSTORE({type:''});
    },
    methods: {
        ...mapMutations(['UPDATECURRENTSTORE']),
        ...mapActions(['getAdminDataLists','staffLists']),
        // titleArr(){
        //     switch (this.storeInfo.type) {
        //         case '0'||'1':
        //             return ['姓名','手机号码','身份证号','性别','导游级别','从业年限','认证状态','操作']
        //         case '2'||'3'||'4':   
        //             return ['姓名','手机号码','性别','操作'] 
        //     }
        // },
        // handleClick() {
        //     this.getDataLists();
        // },
        toAdd () { this.$router.push({name: 'AddGuide',query:{...this.queryCon,tab:this.activeName}}) },
        getDataLists() {
            this.UPDATECURRENTSTORE({type: 2});
            let data = {
                store_type: 4,
                store_id: this.isGroup ? this.$route.query.store : this.storeInfo.storeId,
                search: this.search,
                mobile:this.mobile,
                title:this.title
            }
            this.staffLists({
                data,
                type: this.activeName
            });
        },
        //查看门店详情页
        goStoreDetail(id) {
            let routeUrl = this.$router.resolve({name:'StoreDetail',query:{type:4,id}});
            window.open(routeUrl.href, '_blank');
        },
    }
}
</script>
<style scoped>
    .text-left{
        display: flex;
        justify-content: left;
    }
    .text-left div{
        line-height: 38px;
    }
    .lies{
        margin-right: 12px;
    }
    .load-area{
        border: 1px #E4E7ED solid;
        border-top: none;
    }
</style>
<style>
    .is-active{
        background-color: #fff;
        width: auto;
    }
</style>
